module.exports = __webpack_public_path__ + "img/user-not-selected.7fbda532.svg";